export default "__VITE_ASSET__609d2098__"